<template>
  <QuizeBox from="babe" :postQuestionGet="postBabeQuestionGet" />
</template>
<script>
import { postBabeQuestionGet } from '@/api/babe'
import QuizeBox from '@/components/QuizeBox.vue'

export default {
  name: 'BabeQuizDetail',
  components: { QuizeBox },
  data() {
    return {
      postBabeQuestionGet
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/babe/quizdetail.vue